import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {StockValuationReportModel} from "./stock-valuation-report.model";
import {EntityGroupByReportCriteriaComponent} from "../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";

@Component({
    selector: "wbo-stock-valuation-report",
    templateUrl: "./stock-valuation-report.component.html",
    providers: [provideReportModel(StockValuationReportModel)]
})
export class StockValuationReportComponent extends AbstractReportPage {
    constructor(public model: StockValuationReportModel) {
        super();
    }

    get showInventoryOutletGroupOption(): boolean {
        return this.model.data.reportType !== EntityGroupByReportCriteriaComponent.INVENTORY_VALUE;
    }
}
